export const getLivePositionsState = (state) =>
  state.algoLive.data && state.algoLive.data.state
    ? state.algoLive.data.state
    : {};

export const getIsLivePositions = (state) =>
  state.algoLive.data &&
  state.algoLive.data.state &&
  state.algoLive.data.state.positions &&
  state.algoLive.data.state.positions.length
    ? true
    : false;

export const getLivePositions = (state) =>
  state.algoLive.data &&
  state.algoLive.data.state &&
  state.algoLive.data.state.positions &&
  state.algoLive.data.state.positions.length
    ? state.algoLive.data.state.positions
    : [];

export const getIsLiveData = (state) =>
  state.algoLive.data &&
  state.algoLive.data.state &&
  state.algoLive.data.state.positions &&
  state.algoLive.data.state.positions.length &&
  !state.algoLive.data.state.exitDone
    ? true
    : false;

export const getLiveTableSelectedLegs = (state) => state.algoLive.selectedLegs;

export const geIsLiveTableAnySelectedLegs = (state) =>
  state.algoLive.selectedLegs.length ? true : false;

export const getLiveTableIsSelectAll = (state) => state.algoLive.selectAll;

export const geIsExitSelectedStart = (state) =>
  state.algoLive.exitSelectedStart;

export const getAlgoLiveFeedSymbols = (state) => state.algoLive.symbols;

export const getAlgoLiveUpdatedAt = (state) => state.algoLive.liveFeedUpdatedAt;

export const getAlgoLiveSymbolsUpdatedAt = (state) =>
  state.algoLive.symbolsUpdatedAt;
